export default __webpack_public_path__ + "static/media/Marques.e03d86c0.xlsx";